import { tv } from '@/utils/styles';

interface EmissionsRangeBarProps {
  percentage: number[];
}

const EmissionsRangeBar = ({ percentage }: EmissionsRangeBarProps) => {
  const { barWrapper, bar, barIndicator, barLabels } = styles();
  const rangeWidth = percentage.length > 1 ? percentage[1] - percentage[0] : 0;

  return (
    <div className={barWrapper()}>
      <div className={bar()} />
      {percentage?.map((p, index) => <div key={index} className={barIndicator()} style={{ left: `${p}%` }} />)}
      {percentage && percentage?.length > 1 && (
        <div
          className="absolute top-4 h-[3px] bg-grey-700"
          style={{ left: `${percentage[0]}%`, width: `${rangeWidth}%` }}
        />
      )}
      <div className={barLabels()}>
        <span>Low</span>
        <span>Average</span>
        <span>High</span>
      </div>
    </div>
  );
};

const styles = tv({
  slots: {
    barWrapper: 'relative mx-1 pt-7',
    barLabels: 'mt-1 flex justify-between text-xxs uppercase text-grey-500',
    bar: '-mx-1 h-1.5 rounded bg-gradient-to-l from-error via-yellowDark to-green-300',
    barIndicator:
      'absolute left-0 top-4 -ml-[6px] h-0 w-0 border-x-[6px] border-t-[6px] border-x-transparent border-b-transparent border-t-grey-700',
  },
});

export { EmissionsRangeBar };
